import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	container: {
		margin: `${theme.spacing.small} 0`,
		'& > p, span': {
			marginBottom: theme.spacing.tiny,
		},
	},
	caption: {
		color: theme.palette.neutral[50],
		lineHeight: theme.lineHeight.narrow,
	},
	flightType: {
		'&::first-letter': {
			textTransform: 'capitalize',
		},
	},
}));
